import React, {Component} from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import rightArrow from '../../assets/right-arrow.svg';
import leftArrow from '../../assets/left-arrow.svg';

class BlogHeader extends Component {
  moveScroller(direction) {
    let element = document.querySelector(".le-blog-header .slider-body > div");
    let numOfChild = element.childElementCount;
    let width = element.offsetWidth;
    let scrollAmount = width/numOfChild;

    switch(direction) {
      case 'left' : 
        element.scrollBy({
          left: -scrollAmount-300,
          behavior: 'smooth'
        }); break;

      case 'right' : element.scrollBy({
        left: scrollAmount+300,
        behavior: 'smooth'
      }); break;

      default : 
      element.scrollBy({
        left: scrollAmount+300,
        behavior: 'smooth'
      }); break;
    }
  }

  render() {
    let { articleList } = this.props; 
    return(
      <Row className="le-blog-header">
        <Col md={2} className="slider-navigation">
          <button onClick={()=>this.moveScroller('left')}>
            <img src={leftArrow} alt="left-swipe"/>
          </button>
          <button onClick={()=>this.moveScroller('right')}>
            <img src={rightArrow} alt="left-swipe"/>
          </button>
        </Col>

        <Col md={10} className="slider-body">
          <Row>

            {
              articleList.length?articleList.map((data, index) => (
                <Col md={11} xs={12} key={index}>
                  <Row>
                    <Col md={4}>
                      <img src={data.images.thumbnail} alt="blog"/>
                    </Col>
                    <Col md={8} className="content">
                      <p>{data.date}</p>
                      <h2>{data.title}</h2>
                      <p>{data.summary}</p>
                      <Button className="le-btn-off-white le-btn" size="sm">Read more</Button>
                    </Col>
                  </Row>
                </Col>
              )):null
            }
            
          </Row>
        </Col>
      </Row>
    )
  }
}

export default BlogHeader;